import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import ErrorBoundary from './components/ErrorBoundary';

// Chrome extension hatalarını filtrele (zararsız hatalar)
const originalError = console.error;
const originalWarn = console.warn;
console.error = (...args) => {
  const message = args[0]?.toString() || '';
  // Chrome extension hatalarını filtrele
  if (message.includes('chrome-extension://') || 
      message.includes('ERR_FILE_NOT_FOUND') ||
      message.includes('completion_list.html') ||
      message.includes('content_script.js') ||
      message.includes('Cannot read properties of undefined')) {
    return; // Bu hataları gösterme
  }
  originalError.apply(console, args);
};
console.warn = (...args) => {
  const message = args[0]?.toString() || '';
  // Chrome extension uyarılarını filtrele
  if (message.includes('chrome-extension://') || 
      message.includes('content_script.js')) {
    return; // Bu uyarıları gösterme
  }
  originalWarn.apply(console, args);
};

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <ErrorBoundary>
      <App />
    </ErrorBoundary>
  </React.StrictMode>
);

